/**
 * DOM util
 */
define(function(require, exports, module) {
    'use strict';

    var $ = require('j');

    /**
     * Element width with float precision for calculations
     * @param el
     * @param withMargins
     * @returns {number}
     * @private
     */
    function _floatWidth(el, withMargins) {
        return el.getBoundingClientRect().width +
            (withMargins ? parseFloat($(el).css('margin-left')) + parseFloat($(el).css('margin-right')) : 0);
    }

    /**
     * Element height with float precision for calculations
     * @param el
     * @param withMargins
     * @returns {number}
     * @private
     */
    function _floatHeight(el, withMargins) {
        return el.getBoundingClientRect().height +
            (withMargins ? parseFloat($(el).css('margin-top')) + parseFloat($(el).css('margin-bottom')) : 0);
    }

    var domUtil = {

        getInputValidationValue: function(input) {
            if (input.type === 'checkbox' || input.type === 'radio') {
                return input.checked;
            }

            return domUtil.getInputValue(input);
        },

        getInputValue: function(input) {
            if (input.inputMode === 'decimal') {
                return input.value
                    ? Number(String(input.value).replace(',', '.'))
                    : input.value;
            }

            return input.value;
        },

        getFloatWidth: function(el) {
            return _floatWidth(el);
        },

        getFloatWidthWithMargins: function(el) {
            return _floatWidth(el, true);
        },

        getFloatHeight: function(el) {
            return _floatHeight(el);
        },

        getFloatHeightWithMargins: function(el) {
            return _floatHeight(el, true);
        }

    };

    module.exports = domUtil;
});
